'use strict';

module.exports = function () {
    const footerEl = document.querySelector('footer, .footerMenu');

    if (!footerEl) return;

    /**
     * Toggles badge state when footer overlaps the reCAPTCHA badge.
     */
    function update() {
        const badge = document.querySelector('.grecaptcha-badge');

        if (!badge) return;

        badge.classList.toggle('is-footer-overlap', badge.getBoundingClientRect().bottom > footerEl.getBoundingClientRect().top);
    }

    $(window).on('scroll resize', update);

    if (window.MutationObserver && document.body) new MutationObserver(update).observe(document.body, { childList: true, subtree: true });

    update();
};
